import React, { useState }                              from 'react';
import { Button, OverlayTrigger, Tooltip }              from 'react-bootstrap';
import { useSelector }                                  from 'react-redux';
import moment                                           from 'moment';

import FinProgramadoForm                                from '../treatment/forms/FinProgramadoForm';
import SalaForm                                         from '../treatment/forms/SalaForm';

import { AGENDADA }                                     from '../../../../data/audienceStates';
import { AUDIENCIAS_AGENDAR }                           from '../../../../data/objects';
import { EFECTIVA }                                     from '../../../../data/audienceStates';
import { ICON_CALENDAR, ICON_NO, ICON_OFIJU, ICON_YES } from '../../../extras/icons';

import AudienceService                                  from '../../../../services/AudienceService';
import Authorities                                      from '../../../../services/AuthoritiesService';




const AudienceResume = props => {


    // ---------------------------------------------------------------------------------------------------------------------
    // DEFINICIONES --------------------------------------------------------------------------------------------------------
    // ---------------------------------------------------------------------------------------------------------------------
    
    // Tomo los props
    const { audience } = props;

    // Inicializo el State Local  
    const [showEditCalendario, setShowEditCalendario] = useState(false);
    const [showEditSala, setShowEditSala] = useState(false);

    // Accedo al Store    
    const authorities = useSelector(state => state.auth.authorities);



    // ---------------------------------------------------------------------------------------------------------------------
    // FUNCIONES -----------------------------------------------------------------------------------------------------------
    // ---------------------------------------------------------------------------------------------------------------------

    // Analizo si puede editar la Sala y el Fin Programado
    let canEditSala = false;
    if(audience)
    {   if(audience.estado && audience.estado.id === AGENDADA)
        {   // Verifico permisos
            if(authorities && Authorities.hasPermission(authorities, AUDIENCIAS_AGENDAR))
            {   // Puede editar Sala
                canEditSala = true;
            }
        }
    }

    // Manejo la apertura
    const handleOpenCalendario = () => {
        setShowEditCalendario(true);
    }
    const handleOpenSala = () => {
        setShowEditSala(true);
    }
    // Manejo el cierre
    const handleCloseCalendario = () => {
        setShowEditCalendario(false);
    }
    // Manejo el cierre
    const handleCloseSala = () => {
        setShowEditSala(false);
    }

    

    // ---------------------------------------------------------------------------------------------------------------------
    // RENDERIZO -----------------------------------------------------------------------------------------------------------
    // ---------------------------------------------------------------------------------------------------------------------
    
    return (
        <div className="col-12">
            <div className="card shadow mb-4">
                <div className="card-header py-2 d-flex flex-row align-items-center justify-content-between">
                    <h6 className={`m-0 font-weight-bold text-${ audience.estado.css } text-uppercase`}>
                        { audience.estado.descripcion }
                    </h6>
                    <div className="dropdown no-arrow">
                        {   canEditSala 
                                ? 
                                    <React.Fragment>                                        
                                        <OverlayTrigger
                                            placement = "left"
                                            overlay = {
                                                <Tooltip>
                                                    Editar Sala    
                                                </Tooltip>
                                            }
                                        >      
                                            <Button variant="light" size="sm" className="float-right text-gray-400" onClick={handleOpenSala}>
                                                <ICON_OFIJU />
                                            </Button>
                                        </OverlayTrigger>
                                        <OverlayTrigger
                                            placement = "left"
                                            overlay = {
                                                <Tooltip>
                                                    Editar Horario Programado  
                                                </Tooltip>
                                            }
                                        >      
                                            <Button variant="light" size="sm" className="float-right text-gray-400" onClick={handleOpenCalendario}>
                                                <ICON_CALENDAR />
                                            </Button>
                                        </OverlayTrigger>

                                        <FinProgramadoForm
                                            show = { showEditCalendario }
                                            handleClose = { handleCloseCalendario }
                                            audience = { audience }
                                        />

                                        <SalaForm
                                            show = { showEditSala }
                                            handleClose = { handleCloseSala }
                                            audience = { audience }
                                        />
                                    </React.Fragment>
                                : 
                                    null
                        }
                    </div>
                </div>
                <div className="card-body">
                    <div className="h6 mb-0 font-weight-bold text-gray-800">
                        <div className="row">               
                            <div className="col-11 h5 mb-0 font-weight-bold text-gray-800">
                                <div className="row">
                                    <div className="col-12 mb-1">
                                    { audience.expediente ? `${audience.expediente.numero} - ` : null }
                                    { audience.caratula }
                                    </div>
                                    <div className="col-12 mb-1">
                                        <small>Tipo/s de Audiencia:</small>
                                        <br/>
                                        {   audience.audienciaTipoList.map((type, index) => (
                                                <React.Fragment key={`aiat${type.id}`}>
                                                    {`${index > 0 ? ', ' : ''}${type.descripcion}`}
                                                </React.Fragment>
                                            ))
                                        }
                                    </div>
                                    <div className="col-md-6 mb-1">
                                        <small>Fiscalía:</small> { audience.fiscalia ? audience.fiscalia.descripcion : '' }
                                    </div>
                                    <div className="col-md-6 mb-1">
                                        <small>Fiscal:</small> { audience.fiscal ? `${audience.fiscal.apellido}, ${audience.fiscal.nombre}` : ''}
                                    </div>
                                    <div className="col-md-3 mb-1">
                                        <small>Defensa Oficial:</small> { AudienceService.hasDefensaOficial(audience) ? (<ICON_YES className="text-success" />) : <ICON_NO className="text-danger" /> }
                                    </div>
                                    <div className="col-md-3 mb-1">
                                        <small>Def. Particulares:</small> { AudienceService.hasDefensaParticular(audience) ? (<ICON_YES className="text-success" />) : (<ICON_NO className="text-danger" />) } 
                                    </div>
                                    <div className="col-md-3 mb-1">
                                        <small>Def. Menores:</small> { AudienceService.hasDefensaMenores(audience) ? (<ICON_YES className="text-success" />) : <ICON_NO className="text-danger" /> } 
                                    </div>
                                    <div className="col-md-3 mb-1">
                                        <small>Privado Libertad:</small> { AudienceService.isPrivadoLibertad(audience) ? (<ICON_YES className="text-success" />) : <ICON_NO className="text-danger" /> }
                                    </div>
                                    <div className="col-md-3">
                                        <small>Inicio Prog.:</small>
                                        <br/>
                                        { audience.inicio ? moment(audience.inicio).format('DD/MM/YYYY HH:mm') : '' }
                                    </div>
                                    <div className="col-md-3">
                                        <small>Fin Prog.:</small>
                                        <br/>
                                        { audience.fin ? moment(audience.fin).format('DD/MM/YYYY HH:mm') : '' }
                                    </div>
                                    <div className="col-md-6">
                                        <small>Operador:</small>
                                        <br/>
                                        { audience.operador ? `${audience.operador.apellido}, ${audience.operador.nombre}` : '' }
                                    </div>
                                    <div className="col-md-6">
                                        <small>Sala:</small>
                                        <br/>
                                        { audience.sala ? audience.sala.descripcion : '' }
                                    </div>
                                    {   audience.observacionAgendamiento 
                                            ?
                                                <div className="col-12">
                                                    <small>OBSERVACIÓN AGENDAMIENTO</small>
                                                    <br/>
                                                    { audience.observacionAgendamiento }
                                                </div>
                                            : 
                                                null
                                    }
                                    {   audience.estado.id >= EFECTIVA 
                                            ?
                                                <React.Fragment>
                                                    <div className="col-md-3">
                                                        <small>Inicio Real:</small>
                                                        <br/>
                                                        { audience.inicioReal ? moment(audience.inicioReal).format('DD/MM/YYYY HH:mm') : '' }
                                                    </div>
                                                    <div className="col-md-3">
                                                        <small>Fin Real:</small>
                                                        <br/>
                                                        { audience.finReal ? moment(audience.finReal).format('DD/MM/YYYY HH:mm') : '' }
                                                    </div>
                                                </React.Fragment>
                                            : 
                                                null
                                    }
                                    {   audience.audienciaJuezList && audience.audienciaJuezList.length > 0 
                                            ?
                                                <div className="col-12">
                                                    <small>Juez/ces</small>
                                                    <br/>
                                                    {   audience.audienciaJuezList.filter(judge => judge.anulado === 0).map((judge, index) => (
                                                            `${index > 0 ? ', ' : ''}${judge.juez.nombre} ${judge.juez.apellido}`
                                                        ))
                                                    }
                                                </div>
                                            : 
                                                null
                                    }
                                </div>
                            </div>
                            <div className="col-xs-12 col-md-1 row justify-content-center align-items-center hidden-xs">
                                <i className="fas fa-info-circle fa-2x text-gray-300"></i>
                            </div>
                        </div>
                    </div>
                </div> 
            </div>
        </div>
    );
};

export default AudienceResume;
